export const HOME_PAGE_LINK = 'https://screenmein.com'
